export function showFallbackLang(lang){
    if(this.languages.length > 1 && this.form.fallback_language == lang)
    {
        return lang + ' (Fallback Language)';
    }
    return lang;
}

export function writeStationsCount(count){
    if(count == 1){
        return count+' station'
    }
    if(count > 1 || count == 0){
        return count+' stations'
    }
}

//====Logic is the same for the Tour and for the Station. Logic which is needed for delete
//preview images or logos and prevent fails when delete in fallback language when files exists 
//in not fallback language
//Tour or Station passing as argument [entity]
export function deletePreviewImageOrLogo(type){
    //entity == tour || station
    this.unlink_form.type = type;

    if(this.hasFileInNotFallbackLanguage(type) == true)
    {
        this.showPreventFallbackLangModal('image_or_logo');
        return;
    }

    this.unlink_form.current_language = this.current_language;
    this.unlink_form.post(route(this.entity+'.unlink-logo-preview', this.identifier), {
      preserveScroll: true,
      onSuccess: () => {
        this.unlink_form.type = null;
        this.changeLanguage(this.unlink_form.current_language)
        }
    });
};

export function hasFileInNotFallbackLanguage(full_type){
    //============================for_gallery_images
    if(full_type == 'gallery_image'){
        if(this.current_language == this.$page.props.tour.data.fallback_language){
            const fileInAnotherLanguage = this.$page.props.station.data.gallery
            .filter(el=>el.id == this.delete_item_form.id)[0].image
            .filter(el => el.language != this.$page.props.tour.data.fallback_language);

            if(fileInAnotherLanguage.length){
                return true;
            } else {
                return false;
            }
        }
    }
    //============================for_station_tour_logos_preview_images
    const type = full_type == 'logo_file' ? 'logo' : 'image';
    if(this.form.fallback_language == this.current_language){
        const fileInAnotherLanguage = this.$page.props[this.entity].data[type].filter(el=> el.language != this.current_language);

        if(fileInAnotherLanguage.length){
            return true;
        } else {
            return false;
        }
    }
    //============================for_waypoints
    if(full_type == 'waypoints'){
        if(this.current_language == this.$page.props.tour.data.fallback_language){
            const fileInAnotherLanguage = this.$page.props.tour.data.waypoints
            .filter(el => el.id == this.delete_coordinates_form.waypoint_id)[0]
            .waypoints_resource.file_piles_localized
            .filter(f => f.language != this.current_language);

            if(fileInAnotherLanguage.length){
                return true;
            } else {
                return false;
            }
        }
    }
};

//watcher function
export function deleteInAllLanguagesFormRunning(newState, oldState){
    if(newState == true && this.unlink_form.type){
        this.unlinkImageOrLogoInAllLanguages();
    }
};
//==

export function unlinkImageOrLogoInAllLanguages(){
    const type = this.unlink_form.type == 'logo_file' ? 'logo' : 'image';

    const langsExceptFallback = this.$page.props[this.entity].data[type].filter(el => el.language != this.form.fallback_language);


    //unlink image for all languages except fallback
    for(const el of langsExceptFallback){
        this.files_for_delete_in_languages.push(el.language)
    }
    //than unlink images for fallback language
    this.files_for_delete_in_languages.push(this.form.fallback_language)
    //run recursive function for delete all images
    this.unlinkImageOrLogoByLanguage(0)
    return
};

export function unlinkImageOrLogoByLanguage (number_of_language){
    this.number_of_language_for_file_to_delete = number_of_language;

    if(this.number_of_language_for_file_to_delete == null ||
        this.number_of_language_for_file_to_delete > this.files_for_delete_in_languages.length - 1){
        this.changeLanguage(this.unlink_form.current_language)
        this.unlink_form.type = null;
        this.files_for_delete_in_languages = [];
        this.number_of_language_for_file_to_delete = null;
        this.hidePreventFallbackLangModal();
        return;
    }

    this.unlink_form.current_language = this.files_for_delete_in_languages[this.number_of_language_for_file_to_delete];
    this.unlink_form.post(route(this.entity+'.unlink-logo-preview', this.identifier),{
        preserveScroll: true,
        onSuccess: () => {
            this.unlinkImageOrLogoByLanguage(number_of_language + 1)
        },
    });
}

export function runDeleteInAllLanguagesForm(){
    if(this.preventFallbackLanguageModalContext == 'image_or_logo')
    {
        this.deleteInAllLanguagesFormRunning = true;
    }
    if(this.preventFallbackLanguageModalContext == 'gallery_image')
    {
        this.deleteInAllLanguagesGalleryImageFormRunning = true;
    }
    if(this.preventFallbackLanguageModalContext == 'waypoints')
    {
        this.deleteInAllLanguagesCoordinateDataFormRunning = true;
    }
}

export function showPreventFallbackLangModal(context){
    this.preventFallbackLanguageModalContext = context; //['image_or_logo', 'gallery_image', 'waypoints']
    this.preventFallbackLanguageModalShow = true;
};

export function hidePreventFallbackLangModal(){
    this.preventFallbackLanguageModalShow = false;
    this.deleteInAllLanguagesFormRunning = false;
    this.deleteInAllLanguagesGalleryImageFormRunning = false;
}

export function unlinkGalleryItemsInAllLanguages(){

    const langsExceptFallback = this.gallery.filter(el => el.id == this.delete_item_form.id)[0]
    .image.filter(item => item.language != this.delete_item_form.fallback_language);


    //unlink image for all languages except fallback
    for(const el of langsExceptFallback){
        this.files_for_delete_in_languages.push(el.language)
    }
    //than unlink images for fallback language
    this.files_for_delete_in_languages.push(this.delete_item_form.fallback_language)
    //run recursive function for delete all images
    this.unlinkGalleryItemsByLanguage(0);
    return;
}

export function unlinkGalleryItemsByLanguage(number_of_language){
    this.number_of_language_for_file_to_delete = number_of_language;

    if(this.number_of_language_for_file_to_delete == null ||
        this.number_of_language_for_file_to_delete > this.files_for_delete_in_languages.length - 1){
        this.updateGallery();
        this.delete_item_form.id = null;
        this.files_for_delete_in_languages = [];
        this.number_of_language_for_file_to_delete = null;
        this.hidePreventFallbackLangModal();
        return;
    }

    this.delete_item_form.language = this.files_for_delete_in_languages[this.number_of_language_for_file_to_delete];
    this.delete_item_form.post(route('station.unlink-gallery-item', this.delete_item_form.id),{
        preserveScroll: true,
        onSuccess: () => {
            this.unlinkGalleryItemsByLanguage(number_of_language + 1)
        },
        onError: (err) => {
            this.updateGallery();
            this.delete_item_form.id = null;
            this.hidePreventFallbackLangModal();
        }
    });
    return
}
///=======Coordinates data
export function unlinkCoordinateDataItemsInAllLanguages(){
    const langsExceptFallback = this.$page.props.tour.data.waypoints
    .filter(el => el.id == this.delete_coordinates_form.waypoint_id)[0]
    .waypoints_resource.file_piles_localized
    .filter(f => f.language != this.delete_coordinates_form.fallback_language);

    //unlink image for all languages except fallback
    for(const el of langsExceptFallback){
        this.files_for_delete_in_languages.push(el.language)
    }
    //than unlink images for fallback language
    this.files_for_delete_in_languages.push(this.delete_coordinates_form.fallback_language)
    //run recursive function for delete all images
    this.unlinkCoordinateDataItemByLanguage(0)
}
export function unlinkCoordinateDataItemByLanguage(number_of_language){
    this.number_of_language_for_file_to_delete = number_of_language;

    if(this.number_of_language_for_file_to_delete == null ||
        this.number_of_language_for_file_to_delete > this.files_for_delete_in_languages.length - 1){
        this.delete_coordinates_form.waypoint_id = null;
        this.item_for_delete = null;
        this.files_for_delete_in_languages = [];
        this.changeLanguage(this.delete_coordinates_form.current_language)
        this.hidePreventFallbackLangModal();
        return;
    }

    this.delete_coordinates_form.current_language = this.files_for_delete_in_languages[this.number_of_language_for_file_to_delete];
    this.delete_coordinates_form.delete(route('coordinate.delete', this.$page.props.tour.data.identifier), {
      preserveScroll: true,
      onSuccess: () => {
        this.unlinkCoordinateDataItemByLanguage(number_of_language + 1)
      },
      onError: (err) => {
        this.delete_coordinates_form.waypoint_id = null;
        this.item_for_delete = null;
        this.files_for_delete_in_languages = [];
        this.hidePreventFallbackLangModal();
      }
    });
}
///=======Coordinates data

///=======My Area (Providers)
export function deleteProvidersLogo(providerIdentifier)
{
    this.delete_providers_logo_form.delete(route('provider.logo-delete', providerIdentifier), {
        onSuccess: () => {
            this.toggleModal();
        }
    })
    return;
}
///=======My Area (Providers)
///=======Logic to make order with different errors (inside modal or not)
export function getErrors(place){
    switch (place) {
        // show errors inside user information
        case 'user_information':
            let errors = [];
            Object.keys(this.$page.props.errors).forEach(key => {
                if(
                    key == 'first_name' ||
                    key == 'last_name' ||
                    key == 'email' ||
                    key == 'password'
                ){errors.push(this.$page.props.errors[key])}
            });
        return errors;
        break;

        // show errors inside modal with creating provider
        case 'create_provider':
            errors = [];
            Object.keys(this.$page.props.errors).forEach(key => {
                if(key.includes('newProviderData')){
                    errors.push(this.$page.props.errors[key])
                }
            });
        return errors;
        break;

        // show errors inside teams with user invitation
        case 'email_for_invite':
            errors = [];
            Object.keys(this.$page.props.errors).forEach(key => {
                if(key.includes('_invite_user_to_provider')){
                    errors.push(this.$page.props.errors[key])
                }
            });
        return errors;
        break;
        // show errors inside user information
        case 'tour_design':
            errors = [];
            Object.keys(this.$page.props.errors).forEach(key => {
                errors.push(this.$page.props.errors[key])
            });
        return errors;
        break;
    }
}
///=======Logic to make order with different errors (inside modal or not)
// Slugify a string
export function slugify(str)
{
    str = str.replace(/^\s+|\s+$/g, '');

    // Make the string lowercase
    str = str.toLowerCase();

    // Remove accents, swap ñ for n, etc
    var from = "ÁÄÂÀÃÅČÇĆĎÉĚËÈÊẼĔȆÍÌÎÏŇÑÓÖÒÔÕØŘŔŠŤÚŮÜÙÛÝŸŽáäâàãåčçćďéěëèêẽĕȇíìîïňñóöòôõøðřŕšťúůüùûýÿžþÞĐđßÆa·/_,:;";
    var to   = "AAAAAACCCDEEEEEEEEIIIINNOOOOOORRSTUUUUUYYZaaaaaacccdeeeeeeeeiiiinnooooooorrstuuuuuyyzbBDdBAa------";
    for (var i=0, l=from.length ; i<l ; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    // Remove invalid chars
    str = str.replace(/[^a-z0-9 -]/g, '')
    // Collapse whitespace and replace by -
    .replace(/\s+/g, '-')
    // Collapse dashes
    .replace(/-+/g, '-');

    return str;
}
// Slugify a string
